import { render, staticRenderFns } from "./ShippingCompanyModule.vue?vue&type=template&id=00039fd7"
import script from "./ShippingCompanyModule.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports